import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home', // 注册页面
      component: () => import('@/pages/activityWH/home'),
      name: 'home',
      meta: { title: '医学界·新冠肺炎疫情实时追踪' }
    },
    {
      path: '/', // 注册页面
      redirect: '/home'
    },
    {
      path: '/CommentDetail', // 评论详情
      component: () => import('@/pages/activityWH/CommentDetail'),
      name: 'CommentDetail',
      meta: { title: '医学界·新冠肺炎疫情实时追踪' }
    },
    {
      path: '/Map', // 评论详情
      component: () => import('@/pages/activityWH/map'),
      name: 'map',
      meta: { title: '医学界·新冠肺炎疫情实时追踪' }
    },
    {
      path: '/GuideList', // 评论详情
      component: () => import('./../pages/activityWH/guide'),
      name: 'guideList',
      meta: { title: '医学界·新冠肺炎防护指南' }
    },
    {
      path: '/AllData', // 评论详情
      component: () => import('./../pages/activityWH/allData'),
      name: 'AllData',
      meta: { title: '医学界•全国疫情数据趋势图' }
    },
    {
      path: '/Subscription', // 评论详情
      component: () => import('./../pages/activityWH/subscription'),
      name: 'Subscription',
      meta: { 
        title: '医学界•地区疫情订阅', 
        needAuthorization: true,
      }
    },
    {
      path: '/SubscribeImg', // 订阅详情页
      component: () => import('./../pages/activityWH/subscribeImg'),
      name: 'SubscribeImg',
      meta: { 
        title: '医学界•疫情订阅',
      }
    },
    {
      path: '/sp', // 订阅详情页
      component: () => import('./../pages/activityWH/common/bannerSwiper.vue'),
      name: 'sp',
      meta: { 
        title: '医学界•疫情订阅',
      }
    },
    {
      path: '/videoLiost', // 订阅详情页
      component: () => import('./../pages/activityWH/videoList'),
      name: 'videoLiost',
      meta: { 
        title: '新冠讲堂',
      }
    },
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js